import Http from "./Http";

export class VerificationsService extends Http {
  /**
   * Resend verification link email
   * @param {Object} body
   * @param {string} body.email
   */
  resendVerificationLink(body) {
    return this.post("/verifications", body);
  }

  /**
   * Verify email address
   * @param {Object} body
   * @param {string} body.email
   * @param {string} body.code
   * @returns
   */
  verifyEmail(body) {
    return this.put("/verifications", body);
  }

  /**
   * Start restore password process
   * @param {Object} body
   * @param {string} body.email
   * @returns
   */
  sendRestorePasswordEmail(body) {
    return this.post("/verifications/password", body);
  }

  /**
   * Set new password
   * @param {Object} body
   * @param {string} body.token
   * @param {string} body.password New password to set
   * @returns
   */
  restorePassword(body) {
    return this.put("/verifications/password", body);
  }

  /**
   * Send restore password code
   * @param {Object} body
   * @param {string} body.code
   * @param {string} body.email
   * @returns
   */
  restorePasswordCode(body) {
    return this.put("/verifications/password/code", body);
  }

  /**
   * Create identity verification session
   * @returns {link: "string"}
   */
  createIdentityVerificationSession() {
    return this.post("/verifications/identity");
  }

  /**
   * Create identity verification session
   * @returns {link: "string"}
   */
  createManualVerification(body) {
    return this.post("/verifications/identity/manual", body);
  }

  /**
   * Confirm email change
   * @param {Object} body
   * @param {string} body.code
   * @param {string} body.currentEmail
   * @param {string} body.newEmail
   * @returns
   */
  confirmEmailChange(body) {
    return this.put("/verifications/email", body);
  }
}

VerificationsService.$displayName = "VerificationsService";

export default new VerificationsService();
